const processEntry = (key, value, formData) => {
  if (value === null) {
    formData.append(key, '');
    return;
  }

  if (typeof value === 'string') {
    formData.append(key, value);
    return;
  }

  if (typeof value === 'boolean') {
    formData.append(key, value ? '1' : '0');
    return;
  }

  if (typeof value === 'number') {
    if (Number.isNaN(value)) return;
    formData.append(key, `${value}`);
    return;
  }

  if (value instanceof Blob) {
    formData.append(key, value);
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => processEntry(`${key}[]`, item, formData));
  }
};

export const makeFormData = (data) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined) processEntry(key, value, formData);
  });

  return formData;
};
